var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topbar"},[_c('router-link',{staticClass:"btn btn--main",attrs:{"to":{ name: 'add-account' }}},[_vm._v(_vm._s(_vm.$t('top_bar.add_new_account')))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b960c98","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accounts/Topbar.vue
// module id = 1464
// module chunks = 62